import { render, staticRenderFns } from "./SignatureFinamigo.vue?vue&type=template&id=0c9afdb9&"
import script from "./SignatureFinamigo.vue?vue&type=script&lang=js&"
export * from "./SignatureFinamigo.vue?vue&type=script&lang=js&"
import style0 from "./SignatureFinamigo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports